export async function loadCircleShape(engine, refresh = true) {
    const { CircleDrawer } = await import("./CircleDrawer.js");
    await engine.addShape("circle", new CircleDrawer(), refresh);
}
